import React, {FC, useContext, useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import Header from "Components/Layout/Header";
import Table from "Components/Layout/Table";
import DeleteModal from "../../../../Components/Modal/DeleteModal";
import {Button} from "react-bootstrap";
import FormEmptyOffCanvas from "../../../../Components/Modal/FormEmptyOffCanvas";
import Group from "../../../../Entity/File/Group";
import ProductGroupTable from "../../../../Table/Admin/Edition/Security/ProductGroupTable";
import {useOutletContext} from "react-router-dom";
import Catalog from "../../../../Entity/Catalog";
import FileGroupTable from "../../../../Table/Admin/Edition/Bucket/FileGroupTable";
import Transform from "../../../../Entity/File/Transform";

const FileGroupPage: FC = () => {
    const { t } = useTranslation()

    const [toggleReload, setToggleReload] = useState<boolean>(true)
    const [bucket, setBucket, show, setShow, search, setSearch, setHandleAdd] = useOutletContext<[Catalog, (catalog: Catalog) => void, boolean, (show:boolean) => void, string, (search:string) => void, (handleAdd: (() => void)|undefined) => void]>()
    const [transforms, setTransforms] = useState<Transform[]>([])
    const [transform, setTransform] = useState<Transform|undefined>(undefined)
    const handleClose = (reload = false) => {
        setTransform(undefined)
        setShow(false)
        if (reload) {
            setToggleReload(!toggleReload)
        }
    }
    const handleShow = () => setShow(true)
    // remove
    const [showDelete, setShowDelete] = useState<boolean>(false)
    const handleDeleteClose = (reload = false) => {
        setTransform(undefined)
        setShowDelete(false)
        if (reload) {
            setToggleReload(!toggleReload)
        }
    }
    const handleDeleteShow = () => setShowDelete(true)

    const onSuccess = (transform: Transform) => {
        setTransform(transform)
        setShow(false)
        setToggleReload(!toggleReload)
    }

    const editFileGroup = (transform: Transform) => {
        setTransform(transform)
        handleShow()
    }

    const deleteFileGroup = (transform: Transform) => {
        setTransform(transform)
        handleDeleteShow()
    }

    const actionsRender = (transform: Transform) => (
        <>
            {transform?.isGranted?.edit &&
                <Button
                    variant='outline-primary'
                    size='sm'
                    onClick={() => editFileGroup(transform)}>
                    <i className="fa-solid fa-pencil me-2"></i>
                    {t('app.edit')}</Button>
            }
            {transform?.isGranted?.delete &&
                <Button
                    variant='outline-danger'
                    size='sm'
                    onClick={() => deleteFileGroup(transform)}>
                    <i className="fa-solid fa-trash me-2"></i>
                    {t('app.delete')}</Button>
            }
        </>
    );

    let table = FileGroupTable
    if (table.hasOwnProperty('actions')) {
        table.actions.render = actionsRender;
    }

    return (
        <>
            <Table
                path={`/admin/edition/bucket/${bucket.id}/transform`}
                rows={table}
                toggleReload={toggleReload}
                items={transforms}
                setItems={setTransforms}
                keyword={search}
                setKeyword={setSearch}
            />
            <FormEmptyOffCanvas
                i18nTitle={transform?.id ? 'app.edit_transform' : 'app.add_transform'}
                show={show}
                handleClose={handleClose}
                onSuccess={onSuccess}
                path={`/admin/edition/bucket/${bucket.id}/transform/${transform?.id ?? 'new'}`}
                formPath={!!transform?.id}
                method={transform?.id ? 'patch' : 'post'}
            />
            <DeleteModal
                handleClose={handleDeleteClose}
                show={showDelete}
                path={`/admin/edition/bucket/${bucket.id}/transform/${transform?.id ?? 'error'}`}
                name={'#' + (transform ? `${transform.id} - ${transform.name}` : 'error')}
                archive={true}
            />
        </>
    )
}

export default FileGroupPage
